/* eslint-disable react/prop-types */
import React, { useContext, useState } from 'react';
import { v4 as uuid } from 'uuid';
import FirebaseContext from '../../../context/firebase.context';
import Firebase from '../../../services/firebase';
import { notify } from '../../../functions/notifications';
import './apresentar.scss';
import { FormataTelefone } from '../../../functions/helper';
// import { notify } from '../../../functions/notifications';

function Apresentar() {
  const { expectadores } = useContext(FirebaseContext);
  const [newExpectador, setNewExpectador] = useState({ nome: '', celular: '' });

  function handleChange({ target }) {
    const { name, value } = target;
    const change = name === 'celular' ? FormataTelefone(value) : value;
    setNewExpectador((prevState) => ({
      ...prevState, [name]: change, uid: uuid(),
    }));
  }

  function removeExpectador({ uid }) {
    Firebase.firestore().collection('expectador').doc(uid).delete()
      .then(() => {
        setNewExpectador({ nome: '', celular: '' });
        notify('success', 'Epectador excluído com sucesso');
      })
      .catch(() => {
        setNewExpectador({ nome: '', celular: '' });
        notify('error', 'Erro ao excluir o expectador');
      });
  }
  function adicionarExpectador() {
    const { uid } = newExpectador;
    Firebase.firestore().collection('expectador').doc(uid).set(newExpectador)
      .then(() => {
        setNewExpectador({ nome: '', celular: '' });
        notify('success', 'Epectador cadastrado com sucesso');
      })
      .catch((erro) => {
        setNewExpectador({ nome: '', celular: '' });
        notify('error', `Erro ao cadastrar o expectador: ${erro}`);
      });
  }

  return (
    <div id="apresentar-usuario">
      <div className="header-apresentar">
        <label id="label-nome" className="nome">
          <span>
            Informe o nome
          </span>
          <input
            onChange={(e) => handleChange(e)}
            type="text"
            value={newExpectador.nome}
            required
            id="nome"
            name="nome"
            placeholder="Informe o nome"
          />
        </label>
        <label id="label-telefone" className="telefone">
          <span>
            Informe o telefone
          </span>
          <input
            onChange={(e) => handleChange(e)}
            type="text"
            name="celular"
            value={newExpectador.celular}
            placeholder="(00)9.0000-0000"
          />
        </label>
        <button
          onClick={() => {
            if (newExpectador.nome.length > 0 && newExpectador.celular.length > 0) {
              adicionarExpectador();
            } else {
              notify('error', 'Nome e telefone obrigatórios');
            }
          }}
          type="button"
          className="buttons-transparent"
        >
          <i className="fas fa-plus-circle" />
        </button>
      </div>
      <div className="body-apresentar">
        <div>
          <div className="separator">
            <span>
              Incluir telefone para apresentações
            </span>
          </div>
        </div>
        <div className="seletorOptions-incluidos">
          <div className="apresentar-incluidos">
            {
              expectadores.map((item) => (
                <div className="lista-atributos">
                  <span>
                    {item.nome}
                  </span>
                  <div className="user-telefone">
                    <span>
                      {item.celular}
                    </span>
                    <button
                      onClick={() => removeExpectador(item)}
                      type="button"
                      className="buttons-transparent"
                    >
                      <i className="fas fa-trash" />
                    </button>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Apresentar;
